import { NavigationMenus } from '../../entities';
import { GlobalNavigationConfig } from '../../entities';

export const DEFAULT_CONFIG: GlobalNavigationConfig = {
  footerVariant: 'default',
  headerVariant: 'default',
  logoVariant: 'default',
  menu: {
    copyright: [],
    footer: [],
    header: { primary: [], secondary: [] } as NavigationMenus,
  },
};
